<template>
  <div class="row-book" @click="submitButton(props.info.id)">
    <!-- <img src="@/assets/Rectangle 1115.png" alt="" /> -->
    <slot name="rowBook"></slot>
    <div class="box-p">
      <p style="cursor: pointer">
        <!-- 二轮复习必备神器二轮复习必备神器 -->
        {{ props.info.title }}
      </p>
      <p style="cursor: pointer" v-html="props.info.description">
      </p>
    </div>
  </div>
</template>

<script setup>
import {useRouter } from "vue-router"

const router = useRouter()

const props = defineProps({
  path: {
    type: String,
    default:""
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  // 是否跳转到外部页面
  outPage: {
    type: Boolean,
    default: false,
  },
});

//按钮点击事件
function submitButton(id) {
    if (!props.outPage) {
  router.push({
    path: props.path,
    query:{id}
  });
  } else {
    if (props.path) {
      window.open(props.path);
    }
  }
}

</script>

<style scoped lang="scss">
.row-book {
  width: 104px;
  // width: 100%;
  //height: 120px;
  //   border: 1px solid rgb(38, 0, 255);
  // display: flex;
  // img {
  //   width: 120px;
  //   eight: 120px;
  //   margin-right: 12px;
  //   }

  .box-p {
    // border:1px solid blue;
    
    p:nth-of-type(1) {
      font-size: 14px;
      font-weight: 400px;
      color: #333333;
      // margin-bottom: 12px;

      // height: 48px;
      // min-height: 22px;
      line-height: 20px;

      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;
    }
    p:nth-of-type(2) {
      font-size: 12px;
      // font-size: 15px;
      font-weight: 400px;
      color: #666666;
      margin-top:5px;
      height: 40px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;
    }

    p:hover{
      color:#009DE0;
    }
  }
}
</style>
